import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ConversationalBigSheet } from "@/components/big-sheet/ConversationalBigSheet";

const BigSheetPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-background/95 overflow-x-hidden">
      <div className="container mx-auto py-4 sm:py-6 md:py-8 px-3 sm:px-4">
        {/* Header */}
        <div className="flex items-center gap-3 sm:gap-4 mb-6 sm:mb-8">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate("/artifacts")}
            className="flex items-center gap-2 touch-target-min text-xs sm:text-sm"
          >
            <ArrowLeft className="h-3 w-3 sm:h-4 sm:w-4" />
            <span className="hidden sm:inline">Back to Artifacts</span>
            <span className="sm:hidden">Back</span>
          </Button>
        </div>

        {/* Conversational Big Sheet */}
        <ConversationalBigSheet />
      </div>
    </div>
  );
};

export default BigSheetPage;
